import { render, staticRenderFns } from "./org-select-dialog.vue?vue&type=template&id=76fc240a&"
import script from "./org-select-dialog.vue?vue&type=script&lang=js&"
export * from "./org-select-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports